import React from 'react';
import styles from './Icon.module.css';

const Icon = ({ src, label, revealed, onClick, isWinner, isSelected, number, bonus }) => {
  const isTargetLogo = src === '/logo3_1.png';
  const iconClass = `${styles.icons} ${revealed ? (isWinner ? (bonus ? styles.winning : styles.winningLogo) : '') : ''} ${bonus ? styles.bonus : ''} ${revealed ? styles.disabled : ''} ${isTargetLogo && revealed ? styles.greenLogoContainer : ''}`;
  const wrapperClass = `${styles.iconWrapper} ${isSelected ? styles.selected : ''}`;

  return (
    <div className={wrapperClass} onClick={onClick}>
      <div className={`${iconClass} ${revealed ? styles.isRevealed : ''}`}>
        {!revealed ? (
          number
        ) : (
          <div className={styles.revealedContent}>
            {label ? (
              <div className={isWinner ? styles.winnerLabel : styles.amountLabel}>
                {label.split(' ').map((word, i) => (
                  <div key={i} className={styles.labelWord}>{word}</div>
                ))}
              </div>
            ) : (
              <img src={src} alt="Icon" className={styles.iconImage} />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Icon;
